export enum LoadingProgressStatusPhase {
  preparing = 'Preparing',
  finalizing = 'Finalizing',
  uploading = 'Uploading'
}
